module.exports = __webpack_public_path__ + "static/media/national-2-compressed-web-medium.b2e33630.eot";